import React, { Fragment } from "react";
import Heading from "components/heading/heading";
import { FlexRow } from "components/flex-row/flex-row";
import BaseButton from "components/base-button/base-button";
import { formatMoney } from "../../utils/formatMoney";
import IconMoneyDots from "../../assets/svg/icon-money-dots.svg";

const ModalPaymentDetails = ({ modalProps, closeModal }) => {
  let status;
  switch (modalProps.status) {
    case 0:
      status = "Scheduled";
      break;
    case 1:
      status = "Pending";
      break;
    case 2:
      status = "Applied";
      break;
    case 3:
      status = "Refunded";
      break;
    case 4:
      status = "Returned";
      break;
    case 5:
      status = "Canceled";
      break;
    case 6:
      status = "Failed";
      break;
    case 7:
      status = "Processing";
      break;
    default:
      status = "Unknown";
  }

  return (
    <Fragment>
      <Heading text="Payment Details" icon={IconMoneyDots} />

      <dl>
        <dt>Creditor</dt>
        <dd>{modalProps.creditor.name}</dd>

        <dt>Reference Number</dt>
        <dd>{modalProps.agency.ref_id}</dd>

        <dt>Payment Method</dt>
        <dd>{modalProps.method}</dd>

        <dt>Payment ID</dt>
        <dd>{modalProps.id}</dd>

        {modalProps.agency.payment_id && (
          <>
            <dt>Agency Payment ID</dt>
            <dd>{modalProps.agency.payment_id}</dd>
          </>
        )}

        <dt>Status</dt>
        <dd>{status}</dd>

        <dt>Amount</dt>
        <dd>${formatMoney(modalProps.amount)}</dd>
      </dl>

      <FlexRow className="justify-content--center">
        <BaseButton className="btn--primary" onClick={() => closeModal()}>
          Close
        </BaseButton>
      </FlexRow>
    </Fragment>
  );
};

export default ModalPaymentDetails;
